import React from 'react'
import { Navigate, Route, useLocation, useParams, useResolvedPath } from 'react-router-dom'

export function redirect ({ from = '', to }) {
  let fromList = (typeof from === 'string') ? [from] : from

  let routes = fromList.map(from => {
    let fromWithStar
    if (from.endsWith('/*')) fromWithStar = from
    else if (from.endsWith('/')) fromWithStar = from + '*'
    else fromWithStar = from + '/*'

    let fromWithoutStar = fromWithStar.replace(/\/\*$/, '')

    let fromProp = {}

    if (from === '') {
      fromProp.index = true
    } else {
      fromProp.path = fromWithStar
    }

    return <Route key={from} {...fromProp} element={<Redirect from={fromWithoutStar} to={to} />} />
  })

  return (
    <>
      {routes}
    </>
  )
}

export const Redirect = ({ from, to }) => {
  const { pathname } = useResolvedPath('')
  const { search, hash } = useLocation()
  let parentRoute = pathname.replace(new RegExp(from + '(/|$)'), '')

  // Index redirects (from = '') strip the leading '/' here, leaving a
  // relative segment that <Navigate> would double-join against the route
  // base (e.g. '/tabletop-tools/tabletop-tools/dice-roller/'). Keep it
  // absolute so finalTo is always an absolute path.
  if (parentRoute !== '/' && !parentRoute.startsWith('/')) {
    parentRoute = '/' + parentRoute
  }

  const theRestOfThePath = useParams()?.['*'] ?? ''

  let finalTo = to.endsWith('/') ? to : [parentRoute, to, theRestOfThePath].join('/').replace(/\/+/g, '/') + search + hash

  return <Navigate to={finalTo} replace />
}
